import FormValidator from "base/FormValidator";
import Modal from "modal/Modal";

export class FileDetailsModal extends Modal {
    constructor(file) {
        super({
            destroyOnClose: true,
        });

        this.setContent(
            eotwJSXFactory('div', null, [
                eotwJSXFactory('form', {class: "admin-form js-form"}, [
                    eotwJSXFactory('h2', null, ["Edit file details"]),
                    eotwJSXFactory('br'),
                    eotwJSXFactory('div', {className: "admin-form__row"}, [
                        eotwJSXFactory('label', {className: "admin-form__label"}, ["Label ", eotwJSXFactory('small', null, ["- The label to be displayed"])]),
                        eotwJSXFactory('input', {type: "text", className: "js-label admin-form__input", id: "label", name: "label", value: file.label}),
                        eotwJSXFactory('span', {className: "js-inline-validation"})
                    ]),
                    eotwJSXFactory('div', {className: "admin-form__row"}, [
                        eotwJSXFactory('label', {className: "admin-form__label"}, ["File Name ", eotwJSXFactory('small', null, ["- The name of the file when downloaded"])]),
                        eotwJSXFactory('label', {className: "admin-form__input-icon admin-form__input-icon--right admin-form__input"}, [
                            eotwJSXFactory('input', {type: "text", className: "js-name", id: "name", name: "name", 'data-name': "file name", value: file.name}),
                            eotwJSXFactory('span', null, [".", file.extension])
                        ]),
                        eotwJSXFactory('span', {class: "js-inline-validation"})
                    ]),
                    eotwJSXFactory('div', {className: "admin-modal__buttons"}, [
                        eotwJSXFactory('button', {type: "submit", className: "admin-btn admin-btn--confirm admin-btn--modal"}, ["Update"]),
                        eotwJSXFactory('button', {type: "button", className: "admin-btn admin-btn--cancel admin-btn--modal js-close-btn"}, ["Cancel"])
                    ])
                ])
            ]),
        );

        this.bindEvents();
    }

    bindEvents() {

        let me = this;

        FormValidator.attach(this.$content.find('.js-form')).on('submit', (form) => {
            let data = $(form).serializeJSON();
            me.emit("update", data);
            me.hide();
            return;
        });
    }
}
